document.addEventListener('click', function (event) {
    const openButton = event.target.closest('[data-map-alert-open]');

    if (openButton) {
        const modalId = openButton.dataset.mapAlertOpen;
        const modal = document.getElementById(modalId);

        if (!modal) return;

        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');

        document.body.classList.add('dd-map-alert-open');

        return;
    }

    const closeButton = event.target.closest('[data-map-alert-close]');

    if (closeButton) {
        const modal = closeButton.closest('[data-map-alert]');

        if (!modal) return;

        closeMapAlert(modal);
    }
});

document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    const modal = document.querySelector(
        '[data-map-alert].is-open'
    );

    if (!modal) return;

    closeMapAlert(modal);
});

function closeMapAlert(modal) {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('dd-map-alert-open');
}